'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Link from 'next/link';
import { FC, MouseEvent } from 'react';
import { LinkItem } from '@/types/common';
import css from './style.module.scss';
interface Props {
  links: LinkItem[];
  targetId?: string | null;
  handleLinkClick: (e: MouseEvent<HTMLAnchorElement>, id: string) => void;
}
const NavigationSidebar: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    links,
    targetId,
    handleLinkClick
  } = t0;
  let t1;
  if ($[0] !== handleLinkClick || $[1] !== links || $[2] !== targetId) {
    t1 = links?.map((t2, index) => {
      const {
        url,
        text
      } = t2;
      const paddedIndex = String(index + 1).padStart(2, "0");
      return <Link key={`sidebar_nav_link_${index + 1}`} href={url ? url : "#"} className={clsx(css.link, {
        [css.active]: url.replace("#", "") === targetId
      })} onClick={e => handleLinkClick(e, url.replace("#", ""))}><span className={css.count}>{paddedIndex}</span> <span>{text}</span></Link>;
    });
    $[0] = handleLinkClick;
    $[1] = links;
    $[2] = targetId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className={css.wrapper}>{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default NavigationSidebar;